import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";
import api, { formatErr } from "../lib/api";
import { Logo } from "../components/Shared";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };

  return (
    <div className="p1-container flex justify-center py-16 lg:py-24" data-testid="forgot-password-page">
      <div className="p1-card w-full max-w-md p-10">
        <div className="flex justify-center"><Logo /></div>
        {sent ? (
          <div className="mt-8 text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto h-14 w-14 text-emerald-700" />
            <h1 className="mt-4 font-heading text-2xl font-bold text-stone-900">Check your email</h1>
            <p className="mt-2 text-sm text-stone-600">If <strong>{email}</strong> is registered, we've sent a secure reset link. It expires in 1 hour.</p>
            <Link to="/login" className="p1-btn-primary mt-6 w-full" data-testid="forgot-back-login">Back to Login</Link>
          </div>
        ) : (
          <>
            <h1 className="mt-6 text-center font-heading text-2xl font-bold text-stone-900">Reset your password</h1>
            <p className="mt-1 text-center text-sm text-stone-500">Enter your account email and we'll send you a secure reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <div><label className="p1-label">Email *</label>
                <input type="email" className="p1-input" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" /></div>
              <button type="submit" disabled={busy} className="p1-btn-primary w-full" data-testid="forgot-submit">{busy ? "Sending…" : "Send Reset Link"}</button>
            </form>
            <p className="mt-4 text-center text-sm"><Link to="/login" className="font-semibold text-emerald-900 hover:underline" data-testid="forgot-login-link">← Back to Login</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
